<template>
  <div class="mv-bg-main">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div slot="header" class="clearfix">
            <span>查询条件</span>
          </div>
          <el-form
            :inline="true"
            :model="formInline"
            ref="searchForm"
            label-width="100px"
            class="demo-form-inline"
          >
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="formInline.sysId"
                placeholder="请选择业务系统"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称" >
              <el-input v-model="formInline.userName" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="订单名称" prop="orderName">
              <el-input v-model="formInline.orderName" placeholder="请输入订单名称"></el-input>
            </el-form-item>
            <el-form-item label="订单状态" prop="orderState"   >
              <el-select  v-model="formInline.orderState"  placeholder="请选择订单状态" clearable>
                <el-option
                  label="未付款"
                  value="0"
                ></el-option>
                <el-option
                  label="已付款"
                  value="1"
                ></el-option>
                <el-option
                  label="已完成"
                  value="2"
                ></el-option>
                <el-option
                  label="已取消"
                  value="3"
                ></el-option>
                <el-option
                  label="已删除"
                  value="4"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付渠道" prop="payChannelCode">
              <el-select v-model="formInline.payChannelCode" clearable filterable placeholder="请选择支付渠道">
                <el-option :label="item.payChannelName" :value="item.payChannelCode" v-for="(item, $index) in payChannelData" :key="$index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker
                v-model="formInline.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="float-r">
              <el-button size="small" @click="onReset('searchForm')">重置</el-button>
              <el-button size="small" type="primary" @click="onSearch()">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top:20px"></div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="always">
          <div slot="header" class="clearfix">
            <span>查询结果</span>
          </div>
          <el-row>
            <el-table
              :data="tableList"
              :fit="true"
              style="width: 100%"
            >
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column prop="sysName" :show-overflow-tooltip="tooltip" label="业务系统"></el-table-column>
              <el-table-column prop="userName" :show-overflow-tooltip="tooltip" label="用户名称">
              </el-table-column>
              <el-table-column prop="orderName" :show-overflow-tooltip="tooltip" label="订单名称"></el-table-column>
              <el-table-column prop="orderId" :show-overflow-tooltip="tooltip" label="订单编号">
                <template slot-scope="scope">
                  <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.orderId }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="orderAmount" :show-overflow-tooltip="tooltip" label="订单总额(元)"></el-table-column>
              <el-table-column
                prop="profitAmount"
                width="200"
                :show-overflow-tooltip="tooltip"
                label="利润总额(元)"
              ></el-table-column>
              <el-table-column prop="orderStatus" :show-overflow-tooltip="tooltip" label="状态">
                <template slot-scope="scope">{{ scope.row.orderStatus | dateFormat }}</template>
              </el-table-column>
              <el-table-column prop="payChannelName" :show-overflow-tooltip="tooltip" label="支付渠道">
                <!-- <template slot-scope="scope">{{ scope.row.orderStatus | dateFormat }}</template> -->
              </el-table-column>
              <el-table-column prop="createTime" :show-overflow-tooltip="tooltip" label="订单时间"></el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    :disabled="scope.row.orderStatus === '2' || scope.row.orderStatus === '4'"
                    @click="handleEdit(scope.$index, scope.row)"
                  >状态变更</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <div class="page-navigation">
            <el-pagination
              background
              :current-page.sync="page.num"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next"
              :total="totalRows"
              @size-change="pageSizeChange"
              @current-change="pageCurrentChange"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog  :title="title" @close="closeOrder" width="850px" center :modal-append-to-body='false' :visible.sync="orderDialog">
      <el-form :model="orderInfo" :rules="rule" ref="orderInfo" label-width="120px" >
        <el-form-item label="订单名称" prop="orderName">
          <el-input disabled style="width: 90%;" v-model="orderInfo.orderName" placeholder="请输入订单名称"></el-input>
        </el-form-item>
        <el-form-item label="订单状态" prop="orderStatus"   >
          <el-select :disabled="allDisabled" v-model="orderInfo.orderStatus" style="width: 90%;" placeholder="请选择订单状态" clearable>
            <el-option
              label="未付款"
              value="0"
            ></el-option>
            <el-option
              label="已付款"
              value="1"
            ></el-option>
            <el-option
              label="已完成"
              value="2"
            ></el-option>
            <el-option
              label="已取消"
              value="3"
            ></el-option>
            <el-option
              label="已删除"
              value="4"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单描述" prop="desc">
          <el-input type="textarea" :disabled="allDisabled" style="width: 90%;" maxlength="150" placeholder="订单描述" v-model="orderInfo.desc"></el-input>
        </el-form-item>
        <div style="textAlign: center;" >
          <el-button @click="orderDialog=false">取 消</el-button>
          <el-button type="primary"  @click="orderSave('orderInfo')">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog  title="订单详情"  width="1150px" center :modal-append-to-body='false' :visible.sync="orderDetailDialog">
      <el-form :model="orderDetailInfo"  ref="orderDetailInfo" label-width="120px" >
        <h2 class="refund-dialog-title">订单信息</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="orderDetailInfo.sysId"
                style="width: 90%;"
                placeholder="请选择业务系统"
                clearable
                disabled
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称" prop="userName">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.userName" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="订单名称" prop="orderName">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.orderName" placeholder="请输入订单名称"></el-input>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderId">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.orderId" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="订单描述" prop="remark">
              <el-input type="textarea" disabled style="width: 90%;" maxlength="150" placeholder="订单描述" v-model="orderDetailInfo.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单总额(元)" prop="orderAmount">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.orderAmount" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="利润总额(元)" prop="profitAmount">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.profitAmount" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="订单状态" prop="orderStatus"   >
              <el-select disabled v-model="orderDetailInfo.orderStatus" style="width: 90%;" placeholder="请选择订单状态" clearable>
                <el-option
                  label="未付款"
                  value="0"
                ></el-option>
                <el-option
                  label="已付款"
                  value="1"
                ></el-option>
                <el-option
                  label="已完结"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付渠道" prop="payChannelCode">
              <el-select disabled style="width: 90%;" v-model="orderDetailInfo.payChannelCode" placeholder="请选择支付渠道" clearable>
                <el-option
                  v-for="(item, index) in payChannelData"
                  :key="index"
                  :label="item.payChannelName"
                  :value="item.payChannelCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <h2 class="refund-dialog-title">产品明细</h2> -->
      </el-form>
    </el-dialog>
  </div>
</template>
<script >
export default {
  name: 'cusOrder',
  data () {
    return {
      formInline: {
        sysId: '',
        userName: '',
        orderName: '',
        orderState: '',
        payChannelCode: '',
        createTime: ''
      },
      add: false,
      orderDetailDialog: false,
      payChannelData: [],
      orderDialog: false,
      tableList: [],
      title: '',
      orderDetailInfo: {
        sysId: '',
        orderName: '',
        orderId: '',
        orderState: '',
        payChannelCode: '',
        profitAmount: '',
        orderAmount: '',
        userName: '',
        remark: ''
      },
      orderInfo: {
        orderName: '',
        orderStatus: '',
        desc: ''
      },
      rule: {
        orderName: [
          {
            required: true,
            message: '请输入订单名称',
            trigger: ['blur', 'change']
          }
        ],
        orderStatus: [
          {
            required: true,
            message: '请选择订单状态',
            trigger: ['blur', 'change']
          }
        ]
      },
      custSimpleInfoList: [], // 客户名称列表
      custCopeSimpleInfoList: [], // 拼音客户名称列表
      activeName: '',
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      tooltip: true,
      allDisabled: false,
      totalRows: 0,
      conData: []
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  filters: {
    dateFormat (val) {
      return val === '0' ? '未付款' : val === '1' ? '已付款' : val === '2' ? '已完成' : val === '3' ? '已取消' : '已删除'
    }
  },
  methods: {
    /* 重置操作 */
    onReset (formName) {
      this.formInline = {
        sysId: '',
        custId: '',
        cusOrder: '',
        createTime: ''
      }
      this.custSimpleInfoList = this.custCopeSimpleInfoList
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.query()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.query()
    },
    detail (index, val) {
      let op = {}
      op.orderId = val.orderId
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.customerManagement.queryUserOrderById,
        // url: 'http://172.16.9.104:5010/agw/orderUserCtr/queryUserOrderById',
        data: op
      }).then((response) => {
        let data = response.data.resData
        _this.orderDetailInfo.sysId = Number(data.sysId)
        _this.orderDetailInfo.orderName = data.orderName
        _this.orderDetailInfo.userName = data.userName
        _this.orderDetailInfo.orderId = data.orderId
        _this.orderDetailInfo.remark = data.remark
        _this.orderDetailInfo.orderAmount = data.orderAmount
        _this.orderDetailInfo.payChannelCode = data.payChannelCode
        _this.orderDetailInfo.profitAmount = data.profitAmount
        _this.orderDetailInfo.orderStatus = data.orderStatus
        _this.orderDetailDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    handleEdit (index, val) {
      let op = {}
      this.add = true
      op.orderId = val.orderId
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.customerManagement.queryUserOrderById,
        // url: 'http://172.16.9.104:5010/agw/orderUserCtr/queryUserOrderById',
        data: op
      }).then((response) => {
        let data = response.data.resData
        _this.orderDialog = true
        _this.orderInfo.orderName = data.orderName
        _this.orderInfo.orderId = data.orderId
        _this.orderInfo.desc = data.remark
        _this.orderInfo.orderStatus = data.orderStatus
      }).catch((err) => {
        console.log(err)
      })
      this.title = '订单状态变更'
    },
    orderStateChange (val) {
      if (val === '2' && this.title === '编辑客户订单') {
        this.allDisabled = true
      }
    },
    orderSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.orderId = _this.orderInfo.orderId
          op.orderStatus = _this.orderInfo.orderStatus
          op.remark = _this.orderInfo.desc
          _this.$axios({
            method: 'post',
            url: _this.$API.customerManagement.changeUserOrderStatus,
            // url: 'http://172.16.9.104:5010/agw/orderUserCtr/changeUserOrderStatus',
            data: op
          }).then((response) => {
            _this.query()
            _this.orderDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeOrder () {
      this.orderInfo = {
        orderName: '',
        orderId: '',
        orderStatus: '',
        desc: ''
      }
      this.$refs['orderInfo'].resetFields()
      this.title = ''
      this.orderDialog = false
    },
    handleAdd () {
      this.orderDialog = true
      this.add = false
      this.title = '新增客户订单'
    },
    onSearch () {
      this.page.num = 1
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.page.num
      op.pageSize = this.page.sizeSmall
      op.name = this.formInline.userName
      op.sysIds = sysIds
      op.orderName = this.formInline.orderName
      op.orderStatus = this.formInline.orderState
      op.payChannelCode = this.formInline.payChannelCode
      op.orderStart = this.formInline.createTime ? this.formInline.createTime[0] + ' 00:00:00' : ''
      op.orderEnd = this.formInline.createTime ? this.formInline.createTime[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.customerManagement.queryUserOrderListByPage,
        // url: 'http://172.16.9.104:5010/agw/orderUserCtr/queryUserOrderListByPage',
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableList = response.data.resData.resultList
        _this.totalRows = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.query()
    let _self = this
    this.$store.dispatch('getSystem') // 请求业务系统
    /* 查询支付渠道列表 */
    this.$axios
      .get(this.$API.pay.queryPayChannelList, {})
      .then(function (r) {
        _self.payChannelData = r.data.resData.channelList
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
</style>



// WEBPACK FOOTER //
// src/views/cusOrderManagement/userOrder.vue